import $ from 'jquery';

window.handleMobileView = function() {
    // UX functionality
    var windowWidth = $(window).width();

    /*<![CDATA[*/

    if (windowWidth < 768) {
        $('body')
            .addClass('mobile main-nav-closed')
            .removeClass('minimize-main-nav main-nav-open');
    } else {
        $('body').removeClass('mobile mobile-open-main-nav');
    }

    /*]]>*/
};

window.handleMobileView();
